export default "__VITE_ASSET__BafF3L5x__"